// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/layout/Layout';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import Dashboard from './pages/Dashboard';
import EmailTemplateManager from './components/email/EmailTemplateManager';
import EmailComposer from './components/email/EmailComposer';
import EmailComposerPage from './pages/email/EmailComposerPage';
import EmailList from './components/email/EmailList';
import EmailStats from './components/email/EmailStats';
import Settings from './pages/Settings';
import ProfileGuard from './components/auth/ProfileGuard';
import ProfileSetup from './components/profile/ProfileSetup';
import ContactsPage from './pages/ContactsPage';

import HomePage from './pages/HomePage';
import ServicePage from './pages/ServicePage';

import VAProfileSetup from './components/profile/VAProfileSetup';
import VAProfileView from './components/profile/VAProfileView';
import JobPostPage from './pages/jobs/JobPostPage';
import JobEditPage from './pages/jobs/JobEditPage';
import JobManagementDashboard from './components/jobs/JobManagementDashboard';
import JobDetailView from './components/jobs/JobDetailView';
import VAJobBrowse from './components/jobs/VAJobBrowse';
import VABrowsePage from './pages/providers/VABrowsePage';

import JobApplication from './components/jobs/JobApplication';
import MyApplications from './components/jobs/MyApplications';
import { Home } from 'lucide-react';

function App() {
  return (

    <Router>
      <AuthProvider>
        <div className="App">
          <Routes>

            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />

            {/* Profile setup route - requires auth but not complete profile */}
            <Route
              path="/profile/setup"
              element={
                <ProfileGuard requireProfile={false}>
                  <ProfileSetup />
                </ProfileGuard>
              }
            />

            <Route path="/" element={<HomePage />} />
            <Route path="/service/:serviceId" element={<ServicePage />} />

            <Route path="/app" element={
              <Layout />
            }>

              {/* Dashboard */}
              <Route index element={<Dashboard />} />
              <Route path="contacts" element={<ContactsPage />} />

              {/* Job routes */}
              <Route path="jobs">
                <Route path="post" element={<JobPostPage />} />
                <Route path="edit/:jobId" element={<JobEditPage />} />
                <Route path="manage" element={<JobManagementDashboard />} />
                <Route path=":jobId" element={<JobDetailView />} />
                <Route path="browse" element={<VAJobBrowse />} />
              </Route>

              <Route path="jobs/:jobId/apply" element={<JobApplication />} />
              <Route path="jobs/applications" element={<MyApplications />} />

              {/* Email Management Routes */}
              <Route path="email">
                <Route index element={<Navigate to="templates" replace />} />
                <Route path="compose" element={<EmailComposerPage />} />
                <Route path="templates" element={<EmailTemplateManager />} />
                <Route path="history" element={<EmailList />} />
                <Route path="analytics" element={<EmailStats />} />
              </Route>

              {/* VA routes */}
              <Route path="vas">
                <Route path="browse" element={<VABrowsePage />} />
                <Route path=":vaId" element={<VAProfileView />} />
              </Route>

              <Route path="profile/va-setup" element={<VAProfileSetup />} />
              <Route path="profile/view" element={<VAProfileView />} />
              <Route path="profile/va/:vaId" element={<VAProfileView />} />

              <Route path="settings" element={
                <ProfileGuard>
                  <Settings />
                </ProfileGuard>
              } />

            </Route>

            {/* Catch all - redirect to dashboard */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </AuthProvider>
    </Router>

  );
}

export default App;